import type React from 'react'
import { RowChevron } from './RowChevron'
import styles from './TransferRow.module.css'

export interface TransferRowProps {
  /** Target station id — drives the `station-details-transfer-{id}` a11y id (spec §7). */
  stationId: string
  stationName: string
  lineLocalName: string
  lineHexColor: string
  onTap: () => void
}

/**
 * Single transfer-station row — Figma SD/TransferRow (6972:29525):
 * line-coloured ring (28×28), station name (semiboldPx16 / primary),
 * line name (regularPx12 / secondary), trailing `RowChevron` (Figma's
 * text "›", semiboldPx16 / secondary).
 * a11y id `station-details-transfer-{stationId}` (spec §7).
 */
export function TransferRow({
  stationId,
  stationName,
  lineLocalName,
  lineHexColor,
  onTap,
}: TransferRowProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={onTap}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onTap()
        }
      }}
      data-testid={`station-details-transfer-${stationId}`}
      className={styles.row}
    >
      <span
        data-testid="transfer-line-dot"
        aria-hidden="true"
        className={styles.lineCircle}
        style={{ color: lineHexColor }}
      />
      <div className={styles.text}>
        <span className={styles.title}>{stationName}</span>
        <span className={styles.subtitle}>{lineLocalName}</span>
      </div>
      <span className={styles.spacer} />
      <RowChevron />
    </button>
  )
}
